import { render, staticRenderFns } from "./ModalSwitchCustomer.vue?vue&type=template&id=26f3c627&scoped=true"
import script from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
export * from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModalSwitchCustomer.vue?vue&type=style&index=0&id=26f3c627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3c627",
  null
  
)

export default component.exports